<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <!--use-->
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rowsUse, 'use')"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rowsUse, 'use')" *ngIf="sectionHasAvailableFields('countrySpecificsHighestAndBestUse-use')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rowsUse, 'use')"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rowsUse, 'use')"></span>
          </th>
        </ng-container>
        <th scope="col" colspan="7" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'countrySpecificsHighestAndBestUse.labelUseTitleHighestAndBestUse' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionNameUse" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_country_specifics_use'"
                              [editMode]="editMode" [rows]="rowsUse" [leftColspan]="6" [rightColspan]="6" [data]="widgetData"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRowUse$"
                              [deleteCurrentRow]="deleteCurrentRowUse$" [moveCurrentRowUp]="moveCurrentRowUpUse$"
                              [moveCurrentRowDown]="moveCurrentRowDownUse$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
</div>
